import React from "react";

import { traineesActions } from "@fitness-app/app-store";
import { type TraineeWithAssignedTrainer } from "@fitness-app/data-models/entities/Trainee";

import { useUserRole } from "~/hooks/trainer/useUserRole";
import { useAppDispatch } from "~/store/initializeStore";

/**
 * Active clients missing a training plan or a diet. Scope comes from the thunk: administration reads
 * the whole tenant, a coach only their own list. The list is capped by the query while `count` is
 * exact, so a truncated table can say how much it is hiding.
 */
export const useTraineesWithoutPlan = (enabled = true) => {
  const [clients, setClients] = React.useState<TraineeWithAssignedTrainer[]>([]);
  const [count, setCount] = React.useState(0);
  const [isLoading, setIsLoading] = React.useState(false);
  const dispatch = useAppDispatch();
  const { isAdministration } = useUserRole();

  React.useEffect(() => {
    if (!enabled) {
      return;
    }

    setIsLoading(true);
    void dispatch(traineesActions.fetchTraineesWithoutPlan())
      .unwrap()
      .then((trainees) => {
        setClients(trainees.list);
        setCount(trainees.count);
      })
      .finally(() => {
        setIsLoading(false);
      });
    // isAdministration decides the query scope inside the thunk, so a role that resolves after
    // mount (claims land late) has to re-run the fetch.
  }, [dispatch, enabled, isAdministration]);

  return { clients, count, isLoading };
};
